import { FC } from "react";
import { useAppSelector } from "../../../../../common/store";
import { CalendlyContainer } from "./styles";
import useCalendlyListener from "../../../../hooks/use-calendly-listener";
import { InlineWidget } from "react-calendly";

type Props = {
  onClose: () => void;
}
const CalendlyWidget: FC<Props> = ({ onClose }) => {

  const calendlyUrl = useAppSelector(state => state.theme.themeConfig.calendlyLink);
  const { onCloseClick } = useCalendlyListener(onClose);
  if (!calendlyUrl) return null;

  return (
    <CalendlyContainer id="voa_popup_59o7kg" className={`voa_overlay_59o7kg show`}>
      <div className="voa_close_59o7kg"  
        onClick={onCloseClick}
      >
        &times;
      </div>
      <div id="calendly-inline-widget" className='calendly-inline-widget'>
        {calendlyUrl && (
          <InlineWidget url={calendlyUrl} />
        )}
      </div>
    </CalendlyContainer>
  )
}

export default CalendlyWidget;
